// src/services/blogServices.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  BLOG_LIST,
  BLOG_ADD,
  BLOG_UPDATE,
  BLOG_DELETE,
} from "../../config/constants"; // Adjust endpoints as per your config

const blogServices = createApi({
  reducerPath: "blogServices",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Blog"],
  endpoints: (builder) => ({
    getBlogs: builder.query({
      query: (bodyData) => ({
        url: BLOG_LIST, // Endpoint to fetch blog list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Blog"],
    }),
    addBlog: builder.mutation({
      query: (blogData) => ({
        url: BLOG_ADD, // Endpoint to add a blog
        method: "POST",
        data: blogData, // Blog data for the request body
      }),
      invalidatesTags: ["Blog"],
    }),
    updateBlog: builder.mutation({
      query: ({ blogId, updatedData }) => ({
        url: `${BLOG_UPDATE}/${blogId}`, // Endpoint to update a blog
        method: "PUT",
        data: updatedData, // Updated blog data
      }),
      invalidatesTags: ["Blog"],
    }),
    deleteBlog: builder.mutation({
      query: (blogId) => ({
        url: `${BLOG_DELETE}/${blogId}`, // Endpoint to delete a blog
        method: "DELETE",
      }),
      invalidatesTags: ["Blog"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetBlogsQuery,
  useAddBlogMutation,
  useUpdateBlogMutation,
  useDeleteBlogMutation,
} = blogServices;

// Export the reducer to be included in the store
export default blogServices;
